import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "../styles/dashboard.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AccountSection from "../components/dashboard/account-section";
import { HashLoader } from "react-spinners";
import { getAccountsUnder1m, getAccountsUnder5h, getProductsByType } from "../api/product.api";
import ToastNotification, {
  showToast,
  showTopCenterToast,
} from "../components/toasts/ToastNotification";
import TopUpSection from "../components/dashboard/topup-section";
import UtilitySection from "../components/dashboard/utility-section";
import { getPinnedProducts } from "../api/recommend.api";
import { useLocation, useNavigate } from "react-router-dom";
import { FaUser } from "react-icons/fa";
import { MdElectricBolt } from "react-icons/md";
import { IoIosStar } from "react-icons/io";
import ScrollToTopButton from "../components/scroll-to-top/scroll-to-top-button";
import GiftCardSection from "../components/dashboard/giftcard-section";
import { ReactComponent as MainBanner01 } from "../assets/images/banners/main-banner-01.svg";
import { ReactComponent as MainBanner02 } from "../assets/images/banners/main-banner-02.svg";
import { ReactComponent as MainBanner03 } from "../assets/images/banners/main-banner-03.svg";
import { ReactComponent as MainBanner04 } from "../assets/images/banners/main-banner-04.svg";
import { ReactComponent as MainBanner05 } from "../assets/images/banners/main-banner-05.svg";

const banners = [
  <MainBanner01 className="banner-image" />,
  <MainBanner02 className="banner-image" />,
  <MainBanner03 className="banner-image" />,
  <MainBanner04 className="banner-image" />,
  <MainBanner05 className="banner-image" />,
];

const categories = [
  { name: "Tài Khoản Game", image: require("../assets/images/icons/game-icon.png"), link: "/category/game-account" },
  { name: "Nạp Game Mobile", image: require("../assets/images/icons/topup-icon.png"), link: "/category/top-up" },
  { name: "Tiện Ích", image: require("../assets/images/icons/util-icon.png"), link: "/category/utility-account" },
  { name: "Gift Card", image: require("../assets/images/icons/gift-icon.png"), link: "/category/gift-card" },
];

const Dashboard = () => {
  const [accounts, setAccounts] = useState(null);
  const [packages, setPackages] = useState(null);
  const [utilities, setUtilities] = useState(null);
  const [gifts, setGifts] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("latest");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirect = searchParams.get('redirect');
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Iampesmobile.com";
    fetchProductData();
  }, []);

  useEffect(() => {
    if (redirect) {
      showTopCenterToast("Đăng nhập thành công", "success");
    }
  }, [redirect]);

  useEffect(() => {
    switch (selectedCategory) {
      case "recommend":
        // fetchRecommends();
        break;
      case "pinned":
        fetchPinned();
        break;
      case "latest":
        fetchAccounts();
        break;
      case "under_1m":
        fetchAccountsUnder1m();
        break;
      case "under_5h":
        fetchAccountsUnder5h();
        break;
      default:
        break;
    }
  }, [selectedCategory]);

  const fetchPinned = async () => {
    setLoading(true);

    try {
      const accountRes = await getPinnedProducts(9);

      if (accountRes.success) {
        setAccounts(accountRes.data.pinnedProducts || null);
        console.log(accountRes.data.pinnedProducts)
      }
    } catch (error) {
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  }

  const fetchAccounts = async () => {
    setLoading(true);

    try {
      const accountRes = await getProductsByType("game_account", 100); // Limit = 9

      if (accountRes.success) {
        setAccounts(accountRes.data.products);
      }
    } catch (error) {
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  }

  const fetchProductData = async () => {
    setLoading(true);

    try {
      const packageRes = await getProductsByType("topup_package", 6);
      const utilityRes = await getProductsByType("utility_account", 6);
      const giftRes = await getProductsByType("gift_card", 6);

      if (packageRes.success && utilityRes && giftRes) {
        setPackages(packageRes.data.products);
        setUtilities(utilityRes.data.products);
        setGifts(giftRes.data.products);
      }
    } catch (error) {
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchAccountsUnder1m = async () => {
    setLoading(true);

    try {
      const accountRes = await getAccountsUnder1m(100);

      if (accountRes.success) {
        setAccounts(accountRes.data.accounts || null);
      }
    } catch (error) {
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  }

  const fetchAccountsUnder5h = async () => {
    setLoading(true);

    try {
      const accountRes = await getAccountsUnder5h(100);

      if (accountRes.success) {
        setAccounts(accountRes.data.accounts || null);
      }
    } catch (error) {
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    appendDots: (dots) => (
      <div className="custom-dots-container">
        <ul> {dots} </ul>
      </div>
    ),
    customPaging: (i) => (
      <div className="custom-dot"></div> // Custom dot styling
    ),
    arrows: false,
  };

  if (loading) {
    return (
      <div style={{ height: "100vh" }} className="loader-container">
        <HashLoader color="#fff" />
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <ToastNotification />
      <ScrollToTopButton/>
      {/* Banner Slider */}
      <div className="banner-slider">
        <Slider {...settings}>
          {banners.map((banner, index) => (
            <div key={index}>
              {banner}
            </div>
          ))}
        </Slider>
      </div>

      {/* Categories Section */}
      <div className="categories-section">
        <div className="categories-grid">
          {categories.map((cat, index) => (
            <div key={index} className="category-item">
              <a href={cat.link}>
                <img src={cat.image} alt="Category Icon" className="category-image" />
                <p className="category-name">{cat.name}</p>
              </a>
            </div>
          ))}


        </div>
      </div>

      <AccountSection
        title={"Tài Khoản Game"}
        accounts={accounts}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        navigate={navigate} />
      <TopUpSection title={"Nạp Game Mobile"} packages={packages} />
      <UtilitySection title={"Tiện ích"} utilities={utilities} />
      <GiftCardSection title={"Gift Card"} utilities={gifts}/>

      {/* Why Choose Us Section */}
      <div className="why-choose-us-container">
        <h3 className="why-choose-us-title typing-loop">Tại sao lại chọn chúng tôi?</h3>
        <div className="stats-grid">
          <div class="stat-item">
            <div className="icon-title">
              <FaUser />
              <p>4.000+ người dùng</p>
            </div>
            <p>Được cộng đồng game thủ ngày càng đông đảo tại Việt Nam tin dùng.</p>
          </div>

          <div class="stat-item">
            <div className="icon-title">
              <MdElectricBolt />
              <p>Thời gian hoạt động 99,9%</p>
            </div>
            <p>Hiệu suất đáng tin cậy và ổn định mà bạn có thể tin tưởng, 24/7.</p>
          </div>

          <div class="stat-item">
            <div className="icon-title">
              <IoIosStar />
              <p>Đánh giá 4.9/5</p>
            </div>
            <p>Người dùng yêu thích chúng tôi! Sự hài lòng tuyệt đối trên mọi phương diện.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
